import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { fetchExternalApplications } from "../../Apis/Wallet-api";

export default function WalletSelect({
  value,
  onChange,
  label = "Wallet / agent",
  fullWidth = true,
  size = "small",
  allowEmpty = false,
  autoSelectSingle = true,
}) {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetchExternalApplications()
      .then((rows) => {
        if (active) setApps(Array.isArray(rows) ? rows : []);
      })
      .catch(() => {
        if (active) setApps([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const options = apps.filter((a) => a.wallet_id);

  useEffect(() => {
    if (!autoSelectSingle || loading || value || options.length !== 1) {
      return;
    }
    onChange(Number(options[0].wallet_id));
  }, [autoSelectSingle, loading, value, options, onChange]);

  if (!loading && options.length === 1 && autoSelectSingle) {
    const only = options[0];
    return (
      <Typography variant="body2" color="text.secondary">
        {only.name} (wallet #{only.wallet_id})
      </Typography>
    );
  }

  return (
    <FormControl fullWidth={fullWidth} size={size} disabled={loading}>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        value={value || ""}
        onChange={(e) => onChange(e.target.value ? Number(e.target.value) : "")}
      >
        {allowEmpty && <MenuItem value="">All</MenuItem>}
        {options.map((app) => (
          <MenuItem key={app.wallet_id} value={app.wallet_id}>
            {app.name} (wallet #{app.wallet_id})
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
